"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfProductType = void 0;
var SfProductType;
(function (SfProductType) {
    SfProductType["Pack"] = "Pack";
    SfProductType["Option"] = "Option";
})(SfProductType || (exports.SfProductType = SfProductType = {}));
//# sourceMappingURL=SfProductType.js.map